import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { Select } from 'foundations-components/transitional/components/Select';
import { useEffect, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function VersionHistoryTab({
  releases
}) {
  var _releases$0$releaseTa, _releases$;
  const [selectedVersion, setSelectedVersion] = useState((_releases$0$releaseTa = (_releases$ = releases[0]) === null || _releases$ === void 0 ? void 0 : _releases$.releaseTag) !== null && _releases$0$releaseTa !== void 0 ? _releases$0$releaseTa : '');
  useEffect(() => {
    var _releases$0$releaseTa2, _releases$2;
    setSelectedVersion((_releases$0$releaseTa2 = (_releases$2 = releases[0]) === null || _releases$2 === void 0 ? void 0 : _releases$2.releaseTag) !== null && _releases$0$releaseTa2 !== void 0 ? _releases$0$releaseTa2 : '');
  }, [releases]);
  const options = useMemo(() => releases.map(release => ({
    text: release.releaseTag,
    value: release.releaseTag
  })), [releases]);
  const selectedRelease = useMemo(() => releases.find(release => release.releaseTag === selectedVersion), [releases, selectedVersion]);
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    gap: "300",
    children: /*#__PURE__*/_jsxs(DescriptionList, {
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.infoCard.versionHistory.appVersion"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(Select, {
          value: selectedVersion,
          options: options,
          onChange: e => setSelectedVersion(e.target.value)
        })
      }), selectedRelease && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.infoCard.versionHistory.releaseDate"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: selectedRelease.createdAt,
            format: "ll",
            type: "userTz"
          })
        }), selectedRelease.releaseNotes && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("dt", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.infoCard.versionHistory.releaseNotes"
            })
          }), /*#__PURE__*/_jsx("dd", {
            children: /*#__PURE__*/_jsx(Text, {
              children: selectedRelease.releaseNotes
            })
          })]
        })]
      })]
    })
  });
}